import { Box, Grid, Tbody, Text, Tfoot, Thead } from '@chakra-ui/react'
import type { ShortInsuranceGridItem } from 'BrokerTsLib/src/dtos'
import { useContext } from 'react'

import { Pagination, Table, TableData, TableHeader, TableRow } from '../../components/Grid'
import { Loading } from '../../components/Loading'

import { shortInsurancesCarsContext } from '@/pages/vehicle/shortInsurances'
import { ShortInsuranceRow } from './shortInsuranceRow'

export const TableWrapper = ({ children }: { children: React.ReactNode }) => {
  return <Box sx={{ maxW: '100%', overflow: 'hidden', overflowX: 'auto' }}>{children}</Box>
}

export const ShortInsurancesList = ({
  loading,
  items,
  leftFooterPart,
  withPaginator = false,
}: {
  loading?: boolean
  items: ShortInsuranceGridItem[]
  withPaginator?: boolean
  leftFooterPart?: React.ReactNode
}) => {

  const { currentPage, pageSize, totalCount, setCurrentPage, ...rest } = useContext(shortInsurancesCarsContext)
  loading = loading || rest.loading

  return (
    <Box sx={{ display: 'grid', gap: 4 }}>
      <TableWrapper>
        <Table cellPadding="0" cellSpacing="0">
          <Thead>
            <TableRow hoverEffect={false}>
              <TableHeader>
                <p>Číslo smlouvy</p>
              </TableHeader>

              <TableHeader>
                <p>Datum sjednání</p>
              </TableHeader>

              {/* <TableHeader sx={{ px: 0 }}></TableHeader> */}

              <TableHeader>
                <p>Počátek pojištění</p>
              </TableHeader>

              <TableHeader>
                <p>Konec pojištění</p>
              </TableHeader>

              <TableHeader>
                <p>VIN</p>
              </TableHeader>

              <TableHeader>
                <p>Vozidlo</p>
              </TableHeader>

              <TableHeader>
                <p>Zpracoval</p>
              </TableHeader>
            </TableRow>
          </Thead>

          <Tbody>
            {!loading && ((items?.length ?? 0) > 0) &&
              items.map((x) => {
                return <ShortInsuranceRow key={x.id} item={x} />
              })}

            {!loading && ((items?.length ?? 0) == 0) &&
              <TableRow>
                <TableData colSpan={7} py={8} textAlign={'center'}>
                  <Text>Žádné nabídky k zobrazení</Text>
                </TableData>
              </TableRow>
            }

            {loading &&
              <TableRow>
                <TableData colSpan={7} py={8}>
                  <Loading large={true} />
                </TableData>
              </TableRow>
            }
          </Tbody>

          {(withPaginator) && !loading &&
            <Tfoot>
              <TableRow hoverEffect={false}>
                <TableData colSpan={7}>
                  <Grid gridTemplateColumns='1fr auto 1fr'>
                    {leftFooterPart && leftFooterPart}

                    {!leftFooterPart && <Box></Box>}

                    {withPaginator && (
                      <Pagination totalCount={totalCount} currentPage={currentPage} setCurrentPage={setCurrentPage} maxButtonCount={10} pageSize={pageSize} />
                    )}
                  </Grid>
                </TableData>
              </TableRow>
            </Tfoot>}
        </Table>
      </TableWrapper >
    </Box>
  )
}
